import productImage from "assets/demo/productImage.svg"
import { mockData, type ResultOf } from "graphql-mock"
import { graphql } from "../../graphql"
import type { CheckpointProduct } from "./CheckpointCard"

export type Data = ResultOf<typeof query>

export const query = graphql(`
  query CheckpointIsland($id: ID!) {
    productCategory(id: $id) {
      backgroundImageUrl
      teaserImageUrl
      checkpointIslandBackgroundColor
      isLocked
      mainJourneyProgress: progress {
        certifiedCount
        certifiedMax
      }
      productCategorizations(limit: 3, checkpoint: true) {
        nodes {
          product {
            id
            title
            image
            productType
            progress {
              certified
              starsCount
              starsMax
              highScore
              mandatory
            }
          }
        }
      }
    }
  }
`)

export const mockCheckpointProduct = mockData<CheckpointProduct>({
  id: "1",
  title: "Product 1",
  image: productImage,
  productType: "pdf",
  progress: {
    certified: false,
    starsCount: 0,
    starsMax: 1,
    highScore: 0,
    mandatory: false,
  },
})
